import { ComponentPropsWithoutRef } from 'react'
import PropTypes from 'prop-types'

import './style.scss'

const CheckBox = (props: ComponentPropsWithoutRef<'input'>) => {
  return (
    <label className="CheckBox">
      <input type="checkbox" {...props} />
      <span />
    </label>
  )
}

CheckBox.propTypes = {
  onChange: PropTypes.func.isRequired,
  defaultChecked: PropTypes.bool,
  checked: PropTypes.bool,
}

CheckBox.defaultProps = {
  defaultChecked: false,
}

export default CheckBox
